import React from 'react'
import { CallApi } from '../../Components/common/CommonFunctions';
import { useHistory } from 'react-router-dom';

export const LogOut = () => {
    const history = useHistory
    CallApi({
        endPoint: "/logout",
        payload: {},
        method: "post",
        onSuccess: () => {
            localStorage.clear();
            sessionStorage.clear();
            history.replace('/Login');
        },
    });
}